import { _types } from "../types";
const {
  REQ,
  SILENT_ITEM,
  SILENT_ITEMS,
  SILENT_ITEMS_CATEGORY,
  SILENT_ITEM_CATEGORY,
  ADD_WATCHLIST, 
  REMOVE_FROM_WATCHLIST
} = _types;
const actions = {
  silentItem: (data) => ({
    type: SILENT_ITEM + REQ,
    payload: data,
  }),

  silentItems: (data) => ({
    type: SILENT_ITEMS + REQ,
    payload: data,
  }),
  silentItemByCategory: (data) =>
    ({
      type: SILENT_ITEM_CATEGORY + REQ,
      payload: data,
    }),
  silentItemsByCategory: (data) =>
    ({
      type: SILENT_ITEMS_CATEGORY + REQ,
      payload: data,
    }),
  addWatchlist: (data) =>
    ({
      type: ADD_WATCHLIST + REQ,
      payload: data
    }),
  removeFromWatchlist: (data) =>
  ({
    type: REMOVE_FROM_WATCHLIST + REQ,
    payload: data
  })
};
export default actions;
